import React from 'react'
import propTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'

const _CircularProgress = (props) => {
  const {size, color} = props

  const newSize = 59.5 * size
  const thickness = 3.5 * size

  const margin = size < 0.71
    ? (50 - 59.5 * size) / 2
    : 5.25 * size

  const style = {
    margin: margin,
  }

  if (color) {
    style.color = color
  }

  return (
    <CircularProgress
      size={newSize}
      thickness={thickness}
      style={style}
    />
  )
}

_CircularProgress.propTypes = {
  color: propTypes.string,
  size: propTypes.number.isRequired,
}

export default _CircularProgress
